import { useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import type { PlaceOrderFormDataCoCo, PlaceOrderItemUnitCoCo } from '../placeOrderTypesCoCo.js';

type OrderItemUnitWithLegacyNumberPublicity = PlaceOrderItemUnitCoCo & { numberPublicity?: unknown };

export const useNumberPublicityCoCo = (basketItemId: string, basketItemIndex: number): void => {
  const outerForm = useFormContext<PlaceOrderFormDataCoCo>();
  const placeOrderItemUnits = useWatch({
    control: outerForm.control,
    name: 'products.placeOrderItemUnits',
  });

  useEffect(() => {
    const units: OrderItemUnitWithLegacyNumberPublicity[] = placeOrderItemUnits ?? [];
    const idx = units.findIndex(unit => unit.basketItemId === basketItemId && unit.basketItemIndex === basketItemIndex);
    if (idx === -1 || !('numberPublicity' in units[idx])) {
      return;
    }

    const { numberPublicity: _legacyNumberPublicity, ...rest } = units[idx];
    const nextUnits = [...units];
    nextUnits[idx] = rest;
    outerForm.setValue('products.placeOrderItemUnits', nextUnits, {
      shouldDirty: false,
      shouldTouch: false,
      shouldValidate: false,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [placeOrderItemUnits, basketItemId, basketItemIndex]);
};
